import React, { useState,useContext } from 'react';
import { StoreContext } from "../store";
import {SendNotification } from "../actions";

const NotificationForm = () => {
  const { dispatch, AuthToken} = useContext(StoreContext);
  const [messageType, setMessageType] = useState('Email');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [recipients, setRecipients] = useState('');
  const [sendToSubscribers, setSendToSubscribers] = useState(false); // New state

  const handleSubmit = (e) => {
    e.preventDefault();

    const notification = {
      type: messageType,
      subject: messageType !== 'SMS' ? subject : null,
      message,
      recipient:recipients,// recipients.split(',').map(r => r.trim()),
      sendToSubscribers, 
    };
    alert(JSON.stringify(notification))

    SendNotification(dispatchEvent,notification,AuthToken)
  };

  return (
    <div className="max-w-lg mx-auto p-6 shadow-xl rounded-2xl bg-white mt-10" style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          width: '100%',
          maxWidth: '600px',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '1rem',
          textAlign: 'left',
          boxShadow: '0 0 20px rgba(0,0,0,0.1)',
          border: '1px solid #e5e7eb',
        }}
      >
        <h2 className="text-xl font-bold mb-4">Send Notification</h2>
        <form onSubmit={handleSubmit} className="space-y-4">

          <div>
            <label className="block text-sm font-medium text-gray-700">Message Type</label>
            <select
              value={messageType}
              onChange={(e) => setMessageType(e.target.value)}
              className="mt-1 block w-full p-2 border rounded"
            >
              <option value="Email">Email</option>
              <option value="SMS">SMS</option>
            </select>
          </div>

          {messageType === 'Email' && (
            <div>
              <label className="block text-sm font-medium text-gray-700">Subject</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="mt-1 block w-full p-2 border rounded"
               // required
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="mt-1 block w-full p-2 border rounded"
              rows="4"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Recipients</label>
            <input
              type="text"
              value={recipients}
              onChange={(e) => setRecipients(e.target.value)}
              className="mt-1 block w-full p-2 border rounded"
              placeholder="e.g. user@example.com, +15555550101"
              //required
            />
          </div>

          {/* Send to Subscribers Checkbox */}
          <div className="flex items-center space-x-2">
            <input
              id="sendToSubscribers"
              type="checkbox"
              checked={sendToSubscribers}
              onChange={(e) => setSendToSubscribers(e.target.checked)}
              className="form-checkbox"
            />
            <label htmlFor="sendToSubscribers" className="text-sm text-gray-700">
              Send to all subscribers
            </label>
          </div>

          <br />

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
            style={{
              background: 'rgb(0, 51, 102)',
              fontWeight: '600',
              padding: '0.75rem',
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default NotificationForm;
